"use client";

import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface PPEInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function PPEInternalControls({
  onBack,
  setActiveSection,
  controlsListSection,
}: PPEInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Property, Plant & Equipment"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}
